import React, { useEffect, useState } from 'react';
import { Button, Divider, Result, Row, Tabs } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { useTranslation } from 'react-i18next';

// import '@ant-design/compatible/assets/index.css';


import CustomAddNewPageContent from '../../../components/Content/CustomAddNewPageContent';
import General from './tabs/General';
import Language from './tabs/Language';
import { saveNewsAction } from '../../../actions/AppCms/NewsActions';
import { history } from '../../../utils/history';
import { getCmsLanguagesAction } from '../../../actions/AppCms/CmsLanguageActions';

const { TabPane } = Tabs;

function callback(key) {

}

const AddNews = ({ form }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [finished, setFinished] = useState(false);

  const { cmsLanguageList } = useSelector(store => ({
    cmsLanguageList: store.cmsLanguageReducer.cmsLanguageList,
  }));

  useEffect(() => {
    dispatch(getCmsLanguagesAction());
  }, []);

  const handleGoReports = () => {
    history.push('/news');
  };

  const handleGoAddNew = () => {
    window.location.reload();
  };

  const handleSubmit = e => {
    e.preventDefault();
    // const { form } = this.props;
    form.validateFieldsAndScroll((err, fieldsValue) => {
      if (!err) {
        const content = [];
        cmsLanguageList.map(item => {
          content.push({
            title: fieldsValue['title-' + item.isoLanguage.code],
            description: fieldsValue['description-' + item.isoLanguage.code],
            language: item.isoLanguage.code,
          });
          return null;
        });

        const values = {
          content,
          image: fieldsValue.image ? fieldsValue.image[0] : null,
          date: moment(fieldsValue.date, 'YYYY-MM-DD'),
          published: fieldsValue.published,
        };

        dispatch(saveNewsAction(values)).then(() => {
          setFinished(true);
        });
      }
    });
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 },
      lg: { span: 10 },
      xl: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 },
      lg: { span: 12 },
      xl: { span: 12 },
    },
  };

  return (
    (<CustomAddNewPageContent title={t('appCms.news.addNews')} subTitle={t('appCms.news.news')}>
      {!finished && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        (<Form {...formItemLayout} onSubmit={handleSubmit}>
          <Tabs onChange={callback}>
            <TabPane tab={t('appCms.general')} key="1">
              <General form={form} submit={null} />
            </TabPane>
            {cmsLanguageList.map(item => (
              <TabPane
                tab={
                  item.isoLanguage.code +
                  (item.defaultInMobileApp ? ` (${t('appCms.default')})` : '')
                }
                key={item.isoLanguage.id}
              >
                <Language
                  form={form}
                  langCode={item.isoLanguage.code}
                  language={item}
                  defaultLang={item.defaultInMobileApp}
                />
              </TabPane>
            ))}
          </Tabs>
          <Divider />
          <Row type="flex" justify="center">
            <Button type="primary" htmlType="submit">
              {t('common.save')}
            </Button>
          </Row>
        </Form>)
      )}
      {finished && (
        <Result
          status="success"
          title={t('appCms.news.successfullySaved')}
          extra={[
            <Button type="primary" key="console" onClick={handleGoReports}>
              {t('appCms.news.goToNews')}
            </Button>,
            <Button key="buy" onClick={handleGoAddNew}>
              {t('appCms.news.addNews')}
            </Button>,
          ]}
        />
      )}
    </CustomAddNewPageContent>)
  );
};

AddNews.propTypes = {
  form: PropTypes.object,
  saveNewsAction: PropTypes.func,
  match: PropTypes.object,
  news: PropTypes.object,
  getSpecsTreeAction: PropTypes.func,
  languages: PropTypes.array,
};

const WrappedNewsForm = Form.create({
  name: 'WrappedNews',
})(AddNews);

function mapStateToProps({ newsReducer, cmsLanguageReducer }) {
  const { news } = newsReducer;
  const { cmsLanguageList } = cmsLanguageReducer;
  return { news, cmsLanguageList };
}

const WrappedAddNews = connect(mapStateToProps, {
  saveNewsAction,
  getCmsLanguagesAction,
})(WrappedNewsForm);

export default WrappedAddNews;
